const strings = {
  PASSWORD: {
    SE: 'Lösenord',
    EN: 'Password'
  },
  REPEAT_PASSWORD: {
    SE: 'Upprepa lösenord',
    EN: 'Repeat password'
  },
  PASSWORDS_DO_NOT_MATCH: {
    SE: 'Lösenorden matchar ej',
    EN: 'The passwords do not match'
  },
  MANDATORY_FIELD: {
    SE: 'Obligatoriskt fält',
    EN: 'Mandatory field'
  },
  INTERNAL_ERROR: {
    SE: 'Ett oväntat fel har uppstått, var god försök igen.',
    EN: 'An unexpected error has occured, please try again.'
  },
  EDIT_PASSWORD: {
    SE: 'Uppdatera lösenord',
    EN: 'Edit password'
  }
}

export default strings



// WEBPACK FOOTER //
// ./src/components/containers/EditPasswordModal/strings.js